import React, { FC } from 'react';
import { getLocalStorageDistrictId } from '../../../_core/utils';
import { useSessionStorage } from '../../../../hooks';
import { ProvidersListPage } from './provider-list.page';
import { ProviderColumnName } from '../../hooks/providers-table-columns.hook';
import { AllowedProviderActions } from '../../components/providers-table/providers-table-actions.component';

export const ProvidersListDistrictLevelPage: FC = () => {
	const [sessionStorageDistrictId] = useSessionStorage('districtId');

	const districtId = sessionStorageDistrictId ?? getLocalStorageDistrictId();
	const providerColumnsList: ProviderColumnName[] = [
		'fullName',
		'targetLanguage',
		'verificationType',
		'workStatus',
		'serviceType',
		'totalEngagements',
		'actions',
	];
	const allowedProviderActions: AllowedProviderActions[] = ['view', 'delete', 'edit'];

	return (
		<ProvidersListPage
			currentDistrictId={districtId}
			isAdminRoute={false}
			providerColumnsList={providerColumnsList}
			allowedProviderActions={allowedProviderActions}
		/>
	);
};
